import { createFileRoute } from "@tanstack/react-router";
import { AdServiceLanding } from "@/components/ads/AdServiceLanding";
import taperFadeAsset from "@/assets/opt/taper-fade-tailors-barber.webp";
export const Route = createFileRoute("/barberare-stockholm-ahlens-city/taper-fade")({
  head: () => ({
    meta: [
      { title: "Taper Fade Stockholm City · Från 450 kr | Tailor's Barber Åhléns" },
      { name: "description", content: "Taper Fade & Skin Fade i Stockholm City från 450 kr. Boka online eller drop-in hos Tailor's Barber Åhléns City – 1 min från T-Centralen." },
      { name: "robots", content: "noindex, follow" },
    ],
  }),
  component: () => (
    <AdServiceLanding
      reviewService="taper-fade"
      heroImage={taperFadeAsset}
      heroImageAlt="Taper fade och skin fade hos Tailor's Barber Åhléns City"
      eyebrow="Tailor's Barber · Åhléns City · 1 min från T-Centralen"
      h1="Taper Fade i Stockholm City"
      priceBadge="Från 450 kr"
      salon="ahlens-city"
      primaryCtaLabel="Boka Taper Fade →"
      primaryCtaHref="https://www.bokadirekt.se/boka-tjanst/tailors-barber-stockholm-ahlens-city-37678/skinfade-taper-fade-2173161?utm_source=google&utm_medium=cpc&utm_campaign=ahlens-city"
      secondary="Drop-in välkommen i mån av tid"
      included={[
        { title: "Konsultation", desc: "Vi tar reda på exakt vilken fade du vill ha." },
        { title: "Taper Fade / Skin Fade", desc: "Precision från maskin till hud." },
        { title: "Styling & finish", desc: "Produkter från Tailor's Grooming." },
        { title: "Underhållstips", desc: "Håll faden fräsch längre." },
      ]}
      priceBox="Taper Fade / Skin Fade: 450 kr · inkl. konsultation & styling"
      faq={[
        { q: "Vad är skillnaden mellan taper fade och skin fade?", a: "Taper fade trappar gradvis ner håret, skin fade går hela vägen till huden. Hos oss väljer du nivå." },
        { q: "Hur lång tid tar en taper fade?", a: "35–50 minuter beroende på hårtyp och önskad stil." },
        { q: "Behöver jag boka tid?", a: "Vi rekommenderar bokning men tar drop-in i mån av tid." },
        { q: "Kostar det extra att kombinera med skäggtrimning?", a: "Ja, Hår + Skägg-paketet kostar 680 kr totalt." },
      ]}
    />
  ),
});
